import React from "react"
import DfbRte from "../ui-kit/dfb_rte"
import Section from "./section"

const MGreetings = (props) => {
  return (
    <Section
      baseClass="m-Greetings"
      defaultPaddingTop="extra-small"
      data={props.data}
    >
      <div className="m-Greetings-wrapper">
        <div className="m-Greetings-container">
          <div className="m-Greetings-illustrationWrapper">
            <div className="m-Greetings-illustrationContainer">
              {props.data.greetings.map((item, index) => (
                <a
                  href={"#greeting-" + index}
                  data-illustration={index}
                  className="m-Greetings-illustration"
                >
                  <img
                    src={item.image.src}
                    alt={item.image.alternative}
                    className="m-Greetings-image"
                  />
                </a>
              ))}
            </div>
          </div>
          <ol className="c-Accordion m-Greetings-accordion">
            {props.data.greetings.map((item, index) => (
              <li className="c-Accordion-item" data-item={index}>
                <button className="c-Accordion-button">
                  <span className="c-Accordion-buttonTitle">
                    {item.headline}
                  </span>
                  <span className="c-Accordion-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
                      />
                      <path
                        className="horizontally"
                        fill="currentColor"
                        d="M6 11h12v2H6z"
                      />
                      <path
                        className="vertically"
                        fill="currentColor"
                        d="M13 6v12h-2V6z"
                      />
                    </svg>
                  </span>
                </button>
                <div className="c-Accordion-content" id={"#greeting-" + index}>
                  <div className="c-Accordion-rte">
                    <DfbRte text={item.text} />
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Section>
  )
}

export default MGreetings
